import { createSelector } from "@reduxjs/toolkit";
import { CreateSingleQuoteCommand } from "api/quote";
import { RootState } from "app/store";
import { mapModifiedFees } from "../utils/customFees";

export const selectIsInShoppingCart = (hash: string) => (state: RootState) => {
  const { shoppingCart } = state.pricing;
  if (shoppingCart && shoppingCart.length > 0) {
    return shoppingCart.some(contract => contract.hash === hash) ?? false
  }
  return false
};

export const selectShoppingCart = (state: RootState) => state.pricing.shoppingCart;

export const selectIsCartAvailable = (state: RootState) => {
  const cart = state.pricing.shoppingCart;
  const length = cart?.length ?? 0;
  const isAvailable = length > 0;
  return isAvailable;
};

export const selectShoppingCartItemsMemoized = createSelector(
  [
    (state: RootState) => state.pricing.shoppingCart,
  ],
  (shoppingCart) => {
    return shoppingCart
      .map(contract => {
        return {
          hash: contract.hash,
          name: contract.name,
          contractIdentifier: contract.contractIdentifier,
          productLabel: contract.product?.label || 'Label non disponible',
          productOwner: contract.product?.owner?.name || 'Propriétaire inconnu',
          supportLabel: contract.supportLabel || 'Support non spécifié',
          priceIncludingTax: contract.pricing.priceIncludingTax || 'Support non spécifié',
          clientPrice: contract.pricing.clientPrice || 'Support non spécifié',
        };
      })
      .filter(Boolean);
  }
);

export const selectMappedShoppingCartItems = createSelector(
  [
    (state: RootState) => state.pricing.shoppingCart,
    (state: RootState) => state.pricing.tunnelFeeValues,
  ],
  (shoppingCart, tunnelFeeValues) => {

    return shoppingCart
      .map(contract => {
        return {
          funnelId: contract.id,
          isIndividual: !contract.contractIdentifier,
          contractIdentifier: contract.contractIdentifier,
          fees: mapModifiedFees(contract.fees, tunnelFeeValues),
          variables: contract.variables.map(variable => ({ idVariableValue: variable.variableValueId, value: variable.value })),
          guarantees: contract.guarantees.map(guarantee => ({
            guaranteeId: guarantee.guaranteeTunnelId,
            deductible: guarantee.deductible ? { ...guarantee.deductible, value: guarantee.deductible?.value } : undefined,
            ceiling: guarantee.ceiling ? { ...guarantee.ceiling, value: guarantee.ceiling?.value } : undefined
          })),
        } as CreateSingleQuoteCommand;
      }).filter(Boolean)
  }
);
